import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const imageUrl = (path) => `${API}/files/${path}`;

export const WHATSAPP_PHONE = "917678011693";

export const buildWhatsAppLink = (message) =>
  `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;

export const fmtINR = (n) =>
  typeof n === "number"
    ? `₹${n.toLocaleString("en-IN")}`
    : "₹—";
